import { getConfig } from 'helpers/config';

import { BaseApi } from '../base-api';

export class SampleChatApi extends BaseApi {
  protected readonly passVersionInPrefix = false;
  protected readonly passAppVersionHeader = false;

  startSampleChat = (sampleChatId?: string) =>
    this.post(`${getConfig().sampleChatApiUrl}/api/demo-chat`, {
      onboarding_chat_id: sampleChatId,
    });
}
